import React, { createContext, useContext, useState } from "react";

const CalculatorContext = createContext();

export const CalculatorProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preselectedData, setPreselectedData] = useState(null);

  const openCalculator = (data = null) => {
    setPreselectedData(data);
    setIsOpen(true);
  };

  const closeCalculator = () => {
    setIsOpen(false);
    setPreselectedData(null);
  };

  return (
    <CalculatorContext.Provider
      value={{
        isOpen,
        preselectedData,
        openCalculator,
        closeCalculator,
      }}
    >
      {children}
    </CalculatorContext.Provider>
  );
};

export const useCalculatorModal = () => {
  const context = useContext(CalculatorContext);
  if (!context) {
    throw new Error("useCalculatorModal must be used within a CalculatorProvider");
  }
  return context;
};
